<template>
    <div :style="'text-align: '+(align || 'center')+';'">
        <div>
            <img src="../assets/paper.logo.png" :height="height || 100" alt="">
        </div>
        <span class="font-size" style="color: #4159A7">科学文献有声解读与分享</span>
    </div>
</template>

<script>
    export default {
        name: "PaperSlogan",
        props: ['height', 'align']
    }
</script>

<style scoped>
    .font-size{
        font-size: 14px;
    }
    @media(max-width: 480px) {
        .font-size{
            font-size: 13px
        }
    }
</style>